import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "backdrop", "openIcon", "closeIcon"]

  toggle() {
    const isOpen = !this.sidebarTarget.classList.contains('translate-x-full')

    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.sidebarTarget.classList.remove('translate-x-full')
    this.backdropTarget.classList.remove('hidden')
    this.openIconTarget.classList.add('hidden')
    this.closeIconTarget.classList.remove('hidden')
  }

  close() {
    this.sidebarTarget.classList.add('translate-x-full')
    this.backdropTarget.classList.add('hidden')
    this.openIconTarget.classList.remove('hidden')
    this.closeIconTarget.classList.add('hidden')
  }
}
